import { render, staticRenderFns } from "./TaskListSettings.vue?vue&type=template&id=53c2a8d1&scoped=true"
import script from "./TaskListSettings.vue?vue&type=script&lang=ts"
export * from "./TaskListSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c2a8d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53c2a8d1')) {
      api.createRecord('53c2a8d1', component.options)
    } else {
      api.reload('53c2a8d1', component.options)
    }
    module.hot.accept("./TaskListSettings.vue?vue&type=template&id=53c2a8d1&scoped=true", function () {
      api.rerender('53c2a8d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/TaskListSettings.vue"
export default component.exports